<template>
	<el-dialog title="提示" :visible.sync="visible" :before-close="beforeClose" width="400px">
		<div class="pt-12 pl-12 yx-color-text-primary font-h4-regular">
			<p>商家要求协作样品展示达人的“{{ dataAuthorityRule || '-' }}”与团队设置不符，请修改团队设置</p>
		</div>
		<div slot="footer" class="footer-dialog">
			<el-button type="primary" @click="confirm">我知道了</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	data() {
		return {
			visible: false,
			dataAuthorityRule: '',
		};
	},
	methods: {
		show(dataAuthorityRule) {
			this.dataAuthorityRule = dataAuthorityRule;
			this.visible = true;
		},
		async confirm() {
			this.beforeClose();
		},
		beforeClose() {
			this.dataAuthorityRule = '';
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped></style>
